import React from 'react';
import BottomNavigation from '../components/BottomNavigation';
import './Store.css';

const Store: React.FC = () => {
  const products = [
    { id: 1, name: 'Premium Course Package', price: '$99', originalPrice: '$149', discount: '33%', image: '📚' },
    { id: 2, name: 'Study Materials Bundle', price: '$49', originalPrice: '$79', discount: '38%', image: '📖' },
    { id: 3, name: 'Online Tutoring Session', price: '$29', originalPrice: '$39', discount: '26%', image: '👨‍🏫' },
    { id: 4, name: 'Exam Prep Kit', price: '$59', originalPrice: '$89', discount: '34%', image: '✏️' }
  ];

  return (
    <div className="store-page">
      <header className="store-header">
        <h1>Store</h1>
        <p className="store-subtitle">Browse and purchase learning resources</p>
      </header>

      <div className="store-content">
        <div className="store-products">
          {products.map((product) => (
            <div key={product.id} className="store-product-card">
              <div className="product-image">{product.image}</div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-pricing">
                  <span className="product-price">{product.price}</span>
                  <span className="product-original-price">{product.originalPrice}</span>
                  <span className="product-discount">{product.discount} OFF</span>
                </div>
                <button className="product-buy-button">Add to Cart</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Store;

